var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainbowMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.19751 3.70732H1.38269C7.49191 3.70732 12.4444 8.59944 12.4444 14.6342V15.8049H14.8148C15.4694 15.8049 16 15.2807 16 14.6342C16 6.6597 9.4556 0.195129 1.38269 0.195129C0.728137 0.195129 0.19751 0.719285 0.19751 1.36586V3.70732Z",
    fill: "url(#paint0_radial_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8395 14.6342H16C16 15.2807 15.4693 15.8049 14.8148 15.8049H12.8395V14.6342Z",
    fill: "url(#paint1_linear_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38269 0.195129V3.31708H0.19751V1.36586C0.19751 0.719285 0.728137 0.195129 1.38269 0.195129Z",
    fill: "url(#paint2_linear_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.19751 3.31708H1.38269C7.7101 3.31708 12.8395 8.38391 12.8395 14.6342V15.8049H9.28393V14.6342C9.28393 10.3236 5.74643 6.82927 1.38269 6.82927H0.19751V3.31708Z",
    fill: "url(#paint3_radial_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67902 14.6342H12.8395V15.8049H9.67902V14.6342Z",
    fill: "url(#paint4_linear_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.19751 6.43903V3.31708H1.38269V6.43903H0.19751Z",
    fill: "url(#paint5_linear_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.19751 8.39025C0.19751 9.03682 0.728137 9.56098 1.38269 9.56098C4.21912 9.56098 6.5185 11.8323 6.5185 14.6341C6.5185 15.2807 7.04912 15.8049 7.70368 15.8049H9.67899V14.6341C9.67899 10.1081 5.96462 6.43903 1.38269 6.43903H0.19751V8.39025Z",
    fill: "url(#paint6_radial_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51849 14.6342H9.67899V15.8049H7.70368C7.04912 15.8049 6.51849 15.2807 6.51849 14.6342Z",
    fill: "url(#paint7_radial_66_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38269 9.56098C0.728137 9.56098 0.19751 9.03682 0.19751 8.39025V6.43903H1.38269V9.56098Z",
    fill: "url(#paint8_radial_66_175)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_66_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.3827 14.6342) rotate(-90) scale(14.439 14.6173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.770277,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_175",
    x1: 12.6419,
    y1: 15.2195,
    x2: 16,
    y2: 15.2195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_175",
    x1: 0.790102,
    y1: 0.195129,
    x2: 0.790102,
    y2: 3.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8754C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_66_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.38269 14.6342) rotate(-90) scale(11.3171 11.4568)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723929,
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_66_175",
    x1: 9.67902,
    y1: 15.2195,
    x2: 12.8395,
    y2: 15.2195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_66_175",
    x1: 0.790102,
    y1: 6.43903,
    x2: 0.790102,
    y2: 3.31708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_66_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.38269 14.6341) rotate(-90) scale(8.19512 8.2963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59513,
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_66_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.32096 15.2195) scale(3.35802 8.84552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_66_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.790102 9.7561) rotate(-90) scale(3.31707 63.678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowMeta);
export default __webpack_public_path__ + "static/media/rainbow_meta.0392a521b811d146116d0ac636d2ede3.svg";
export { ForwardRef as ReactComponent };